import { render, staticRenderFns } from "./TaskAllocationEditView.vue?vue&type=template&id=37ab2a75&"
import script from "./TaskAllocationEditView.vue?vue&type=script&lang=js&"
export * from "./TaskAllocationEditView.vue?vue&type=script&lang=js&"
import style0 from "./TaskAllocationEditView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports